import React from 'react'
import portfolio from '../../../js/portfolio/portfolio'
import TechStack from './TechStack'
import { Link } from 'react-router-dom'

const V2PortfolioCard = () => {
  return (
    <section id="PortfolioCardV2">
        {portfolio.map((item) => (
            <div className="pc2-wrap" key={item.id}>
                <div className="pc2-image-wrap">
                    <img src={item.cover_image} alt={item.title} className="pc2-image" />
                </div>
                <div className="pc2-detail">
                    <div className="pc2-detail-title">
                        <h2>{item.title}</h2>
                        <h2>({item.completion_year})</h2>
                    </div>
                    <div className="pc2-infowrap">
                        <div className="pc2-techstackwrap">
                            <TechStack stack={item.stack.slice(0, 4)} />
                            {item.stack.length > 4 && (
                            <span className="pc2-more-stack">
                                more
                            </span>)}
                        </div>
                        <Link to={`/portfolio/${item.id}`} className="pc2-view-project">
                            View Project
                        </Link>
                    </div>
                </div>
            </div>
        ))}
    </section>
  )
}

export default V2PortfolioCard